import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuftragSearchRequestMeta, BatchAuftragService } from 'app/core/batch-auftrag-api';
import { TimepointService } from 'app/core/services/timepoint.service';
import { submit } from 'app/system/batch-auftrag/batch-auftrag.functions';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { Subscription } from 'rxjs';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapiLoginService } from 'app/core/extension/login/capi-login-service';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { CapFormColumnsDirective } from '../../../../shared/form-control/form-columns.directive';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { DatepickerComponent } from '../../../../shared/datepicker/datepicker.component';
import { KompaktBenutzerPipe } from '../../../../shared/kompaktdarstellung/benutzer/kompakt-benutzer-pipe';

@Component({
  selector: 'cap-auftrag-suche',
  templateUrl: './auftrag-suche.component.html',
  styleUrls: ['./auftrag-suche.component.scss'],
  imports: [
    FormsModule,
    CapFormColumnsDirective,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    DatepickerComponent,
    TranslatePipe,
    KompaktBenutzerPipe
  ]
})
export class AuftragSucheComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild('auftragJahr', { static: true })
  jahrField: ElementRef;

  auftrag: AuftragSearchRequestMeta;

  private subscription: Subscription;

  exportResultWebTyp: AuftragSearchRequestMeta.ExportResultWebTypEnum[] = ['FEHLERHAFT', 'FEHLERLOS', 'IMARBEIT', 'AMWARTEN'];
  datenexportAuftragTyp: AuftragSearchRequestMeta.DatenexportAuftragTypEnum[] = [
    'STANDARD',
    'BODENBEDECKUNGSFILTER',
    'GRUNDSTUECKLISTE',
    'GEBAEUDELISTE',
    'EIGENTUEMERLISTE',
    'GELAN',
    'EIGENTUEMERART',
    'GEAENDERTEGS',
    'GELOESCHTEGS',
    'EIGENTUEMERREGISTER',
    'RECHTEREGISTER',
    'GEAENDERTEBODENBEDGS',
    'GELOESCHTBODENBEDGS'
  ];

  constructor(
    private auftragservice: BatchAuftragService,
    stateService: SearchStateService,
    private route: ActivatedRoute,
    private router: Router,
    private timpointService: TimepointService,
    private translate: TranslateService,
    public loginService: CapiLoginService
  ) {
    super(stateService);
    keysToTranslate<string>([
      'Verarbeitungsstatus',
      'auftragsTyp',
      'Auftrag.SucheTitel',
      'stapelverarbeitung.search.breadcrumb',
      'Auftrag'
    ]);
    keysToTranslate<string>([
      'datenexport.STANDARD',
      'datenexport.BODENBEDECKUNGSFILTER',
      'datenexport.GRUNDSTUECKLISTE',
      'datenexport.GEBAEUDELISTE',
      'datenexport.EIGENTUEMERLISTE',
      'datenexport.GELAN',
      'datenexport.EIGENTUEMERART',
      'datenexport.GEAENDERTEGS',
      'datenexport.GELOESCHTEGS',
      'datenexport.EIGENTUEMERREGISTER',
      'datenexport.RECHTEREGISTER',
      'datenexport.GEAENDERTEBODENBEDGS',
      'datenexport.GELOESCHTBODENBEDGS'
    ]); // AuftragSearchRequestMeta.DatenexportAuftragTypEnum
    keysToTranslate<AuftragSearchRequestMeta.ExportResultWebTypEnum>(['FEHLERHAFT', 'FEHLERLOS', 'IMARBEIT', 'AMWARTEN']);
  }

  ngOnInit() {
    if (this.stateService.lastRequest) {
      this.auftrag = this.stateService.lastRequest;
    } else {
      this.auftrag = <AuftragSearchRequestMeta>{};
    }

    this.sortAuftragsTypen();
    this.translate.onLangChange.subscribe((data) => this.sortAuftragsTypen());

    this.auftragservice.searchAuftragTemplate().subscribe((template) => {
      this.auftrag = this.copyLastRequest(template);
    });
    this.jahrField.nativeElement.focus();
  }

  private sortAuftragsTypen() {
    this.datenexportAuftragTyp.sort((a, b) => {
      if (!a) {
        return -1;
      }
      if (!b) {
        return 1;
      }
      return this.translate.instant('datenexport.' + a).localeCompare(this.translate.instant('datenexport.' + b));
    });
  }

  onSubmit(): void {
    this.stateService.lastRequest = this.auftrag;
    this.timpointService.resetTimepoint();
    submit(this.form, SearchMode.searchStandard, this.auftrag, this.router, this.route);
  }

  onReset() {
    this.auftrag.ersteller = null;
    this.form.reset();
    this.subscription = this.auftragservice.searchAuftragTemplate().subscribe((template) => {
      this.auftrag = template;
      this.stateService.lastRequest = template;
    });
    this.jahrField.nativeElement.focus();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
